export const SmartDocsMode_MDM = 'mdm';
export const SmartDocsMode_Logs = 'logs';
export const SmartDocsMode_Note = 'note';
export const SmartDocsModes = [SmartDocsMode_MDM, SmartDocsMode_Logs, SmartDocsMode_Note];
//# sourceMappingURL=types.js.map